import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import AppIcon from '../../components/AppIcon';
import { useUserAccess } from '../../context/UserAccessContext';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1/api';

const Login = () => {
  const navigate = useNavigate();
  const { refreshUser } = useUserAccess();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok || !data?.success || !data?.data?.token) {
        throw new Error(data?.data?.message || 'Identifiants invalides');
      }

      localStorage.setItem('authToken', data.data.token);
      await refreshUser();
      navigate('/', { replace: true });
    } catch (err) {
      console.error(err);
      setError(err.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Helmet>
        <title>Connexion - CRM BOOSTER</title>
      </Helmet>

      <div className="w-full max-w-md bg-card rounded-2xl shadow-elevation-3 border border-border p-8 space-y-6">
        <div className="flex flex-col items-center space-y-3">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
            <AppIcon name="Lock" size={24} className="text-primary" />
          </div>
          <div className="text-center space-y-1">
            <h1 className="text-2xl font-semibold text-foreground">
              Connexion
            </h1>
            <p className="text-sm text-muted-foreground">
            Accédez à vos outils.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">
              Email professionnel
            </label>
            <Input
              type="email"
              placeholder="mail@deepblock.eu"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">
              Mot de passe
            </label>
            <div className="relative">
              <Input
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="pr-10"
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-1.5 text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth"
                aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
              >
                <AppIcon name={showPassword ? 'EyeOff' : 'Eye'} size={18} />
              </button>
            </div>
          </div>

          {error && (
            <p className="text-sm text-error">
              {error}
            </p>
          )}

          <Button
            type="submit"
            fullWidth
            size="lg"
            iconName="LogIn"
            disabled={loading}
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;

